/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContactInputFromJSON, ContactInputToJSON, } from './ContactInput';
import { ConsumerMeteringPointsInnerFromJSON, ConsumerMeteringPointsInnerToJSON, } from './ConsumerMeteringPointsInner';
import { ConsumerAddressFromJSON, ConsumerAddressToJSON, } from './ConsumerAddress';
import { ConsumerCustomerFromJSON, ConsumerCustomerToJSON, } from './ConsumerCustomer';
/**
 * Check if a given object implements the Consumer interface.
 */
export function instanceOfConsumer(value) {
    if (!('planId' in value) || value['planId'] === undefined)
        return false;
    if (!('contacts' in value) || value['contacts'] === undefined)
        return false;
    if (!('address' in value) || value['address'] === undefined)
        return false;
    if (!('customer' in value) || value['customer'] === undefined)
        return false;
    if (!('meteringPoints' in value) || value['meteringPoints'] === undefined)
        return false;
    return true;
}
export function ConsumerFromJSON(json) {
    return ConsumerFromJSONTyped(json, false);
}
export function ConsumerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'planId': json['plan_id'],
        'contacts': (json['contacts'].map(ContactInputFromJSON)),
        'address': ConsumerAddressFromJSON(json['address']),
        'customer': ConsumerCustomerFromJSON(json['customer']),
        'accountManagerId': json['account_manager_id'] == null ? undefined : json['account_manager_id'],
        'meteringPoints': (json['meteringPoints'].map(ConsumerMeteringPointsInnerFromJSON)),
    };
}
export function ConsumerToJSON(json) {
    return ConsumerToJSONTyped(json, false);
}
export function ConsumerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'plan_id': value['planId'],
        'contacts': (value['contacts'].map(ContactInputToJSON)),
        'address': ConsumerAddressToJSON(value['address']),
        'customer': ConsumerCustomerToJSON(value['customer']),
        'account_manager_id': value['accountManagerId'],
        'meteringPoints': (value['meteringPoints'].map(ConsumerMeteringPointsInnerToJSON)),
    };
}
